module.exports = __webpack_public_path__ + "img/s8.98a767a.png";